import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { IoPause, IoPlay } from "react-icons/io5";
import "../../Css/homeCategory/HomeCategory.css";
import productImageCloth from "../../Images/Images/clothImage01.jpeg";
import productreelsCloth from "../../Images/Video/clothes01.mp4";

const   HomeClothProduct = () => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(true);

    const handlePlay = async () => {
        try {
            await videoRef.current?.play();
            setIsPlaying(true);
        } catch (error) {
            console.error("Unable to play video:", error);
        }
    };

    const handlePause = () => {
        videoRef.current?.pause();
        setIsPlaying(false);
    };

    return (
        <div className="home-category-product">
            <div className="home-category-page-main-con">
                <div className="row">
                    <div className="col-md-6 m-0 p-0">
                        <div className="home-category-page-right-con">
                            <div className="home-category-page-right-reels-con">
                                <video
                                    ref={videoRef}
                                    src={productreelsCloth}
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    onPlay={() => setIsPlaying(true)}
                                    onPause={() => setIsPlaying(false)}
                                    style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center center" }}
                                />
                                <div className="home-category-page-video-controls">
                                    {isPlaying ? (
                                        <button
                                            type="button"
                                            onClick={handlePause}
                                            className="home-category-page-video-control-btn"
                                            aria-label="Pause video"
                                        >
                                            <IoPause />
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            onClick={handlePlay}
                                            className="home-category-page-video-control-btn"
                                            aria-label="Play video"
                                        >
                                            <IoPlay />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="home-category-page-left-con">
                            <div className="home-category-page-left-main-con">
                                {/* <div className="home-category-page-left-image-con-top">
                                    <div className="home-category-page-left-image-con">
                                        <img
                                            src={productImageCloth}
                                            alt="Clothing collection preview"
                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                        />
                                    </div>
                                </div>
                                <div className="home-page-category-section-text">
                                    <h2>Apparel</h2>
                                    <h3>Soft layers, clean lines.</h3>
                                </div> */}

                                {/* <h2>THE PHILOSOPHY</h2> */}
                                <h3>1FIVE <span> Apparel</span></h3>
                                <h4>1FIVE  is built for those who value simplicity, craftsmanship, and effortless style. Our apparel blends premium quality with contemporary design, creating wardrobe essentials that look refined and feel exceptional.</h4>
                                <Link to="/apparel" className="home-category-page-left-main-bottom-link">
                                    DISCOVER MORE
                                </Link>

                                {/* <div className="home-category-page-left-main-bottom-con">
                                    <Link to="/women" className="home-category-page-left-main-bottom-link">
                                        DISCOVER
                                    </Link>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeClothProduct;